import React from 'react'
import '../Common.scss'
import defaultImage from '../../../assets/default.png'
import {Image} from '../../../components/CustomImage'

export default function FalseCeilingPlanView({pageDetails}) {
  const imagesData = pageDetails.images
  return (
    <>
      <div className="page-heading">{pageDetails?.name}</div>
      <div className="page-over-container">
      <div className="image-section-1">
        {
            imagesData.map((image, index) => {
                return (
                    <div key={index}>
                        <p className="image-container-heading">{image?.name ? image?.name :"3D View"}</p>
                        <Image crossOrigin="anonymous" className="page-image" src={image.imageUrl ? image.imageUrl : defaultImage} alt="" />
                    </div>
                )
            })
        }
       </div>
      </div>
    </>
  )
}
